export class TripStatuses {
  public static REQUESTED = 'REQUESTED'
  public static DISPATCH_ASSIGNED_DRIVER = 'DISPATCH_ASSIGNED_DRIVER'
  public static ACCEPTED = 'ACCEPTED'
  public static NO_RESPONSE_OPERATOR = 'NO_RESPONSE_OPERATOR'
  public static NO_SHOW_RIDER = 'NO_SHOW_RIDER'
  public static TO_PICK_UP = 'DRIVING_TO_PICK_UP'
  public static AT_PICK_UP = 'ARRIVED_AT_PICK_UP'
  public static PICKED_UP = 'PICKED_UP'
  public static TO_DROP_OFF = 'DRIVING_TO_DROP_OFF'
  public static AT_DROP_OFF = 'ARRIVED_AT_DROP_OFF'
  public static DROPPED_OFF = 'DROPPED_OFF'
  public static COMPLETED = 'COMPLETED'
  public static MANUALLY_COMPLETED = 'MANUALLY_COMPLETED'
  public static COMPLETED_PENDING_PAYMENT = 'COMPLETED_PENDING_PAYMENT'
  public static CANCELLED = 'CANCELLED'
  public static DRIVER_CANCELLED = 'DRIVER_CANCELLED'
  public static RIDER_CANCELLED = 'RIDER_CANCELLED'
  public static CANCEL_BILLABLE = 'CANCEL_BILLABLE'
  public static REJECTED = 'REJECTED'
  public static BOOKING_FAILED = 'BOOKING_FAILED'
  public static INTEGRATION_FAILED = 'INTEGRATION_FAILED'
  public static SCHEDULED = 'SCHEDULED'
  public static SCHEDULE_REQUESTED = 'SCHEDULE_REQUESTED'
  public static SCHEDULE_ACCEPTED = 'SCHEDULE_ACCEPTED'
  public static WAITING = 'WAITING'
  public static PENDING = 'PENDING'
  public static WILL_CALL = 'WILL_CALL'
  public static EXPIRED = 'EXPIRED'
}

export class TripStages {
  public static requesting = 'REQUESTING'

  public static waitingForPickUp = 'WAITING_FOR_PICKUP'

  public static enRoute = 'EN_ROUTE'

  public static completed = 'PROCESSED'
}

export type TripStage = typeof TripStages.requesting | typeof TripStages.waitingForPickUp | typeof TripStages.enRoute

export const activeTripStatuses = [
  TripStatuses.WAITING,
  TripStatuses.REQUESTED,
  TripStatuses.ACCEPTED,
  TripStatuses.TO_PICK_UP,
  TripStatuses.AT_PICK_UP,
  TripStatuses.PICKED_UP,
  TripStatuses.TO_DROP_OFF,
  TripStatuses.AT_DROP_OFF
]

export const activeTripStatusesWithDriver = [
  TripStatuses.ACCEPTED,
  TripStatuses.TO_PICK_UP,
  TripStatuses.AT_PICK_UP,
  TripStatuses.PICKED_UP,
  TripStatuses.TO_DROP_OFF,
  TripStatuses.AT_DROP_OFF
]

export const onDemandNoDriver = [TripStatuses.WAITING, TripStatuses.REQUESTED]

export const willCallTripStatuses = [TripStatuses.WILL_CALL]
export const expiredTripsStatusesDashboard = [TripStatuses.EXPIRED]

export const scheduledTripStatuses = [
  TripStatuses.SCHEDULED
  // TripStatuses.SCHEDULE_REQUESTED,
  // TripStatuses.SCHEDULE_ACCEPTED,
  // TripStatuses.WAITING
]

export const issuesTripStatuses = [
  TripStatuses.EXPIRED,
  TripStatuses.NO_RESPONSE_OPERATOR,
  TripStatuses.NO_SHOW_RIDER,
  'stuck',
  TripStatuses.BOOKING_FAILED,
  TripStatuses.INTEGRATION_FAILED,
  TripStatuses.REJECTED
]

export const requestingTripStatuses = [TripStatuses.REQUESTED]
export const waitingForPickupTripStatuses = [TripStatuses.ACCEPTED, TripStatuses.TO_PICK_UP, TripStatuses.AT_PICK_UP]
export const enRouteTripStatuses = [TripStatuses.PICKED_UP, TripStatuses.TO_DROP_OFF, TripStatuses.AT_DROP_OFF]
export const completedTripStatuses = [TripStatuses.COMPLETED, TripStatuses.CANCELLED, TripStatuses.REJECTED]
export const completedTripStatusesDashboard = [
  TripStatuses.COMPLETED,
  TripStatuses.MANUALLY_COMPLETED,
  TripStatuses.COMPLETED_PENDING_PAYMENT
]
export const unsassignedTripStatusesDashboard = [
  TripStatuses.WAITING,
  TripStatuses.SCHEDULE_REQUESTED,
  TripStatuses.REQUESTED,
  TripStatuses.DISPATCH_ASSIGNED_DRIVER,
  TripStatuses.NO_RESPONSE_OPERATOR
]
export const cancelledTripsStatusesDashboard = [
  TripStatuses.CANCELLED,
  TripStatuses.CANCEL_BILLABLE,
  TripStatuses.DRIVER_CANCELLED,
  TripStatuses.RIDER_CANCELLED
]
export const incompleteTripStatusesDashboard = [TripStatuses.NO_RESPONSE_OPERATOR, TripStatuses.NO_SHOW_RIDER]
export const alertStatusTripStatusesDashboard = [
  TripStatuses.WAITING,
  TripStatuses.NO_RESPONSE_OPERATOR,
  TripStatuses.DISPATCH_ASSIGNED_DRIVER,
  TripStatuses.REQUESTED,
  TripStatuses.SCHEDULE_REQUESTED
]
export const failedTripStatusesDashboard = [
  TripStatuses.BOOKING_FAILED,
  TripStatuses.INTEGRATION_FAILED,
  TripStatuses.REJECTED
]
export const operatorAllowedTripStatuses = [
  TripStatuses.TO_PICK_UP,
  TripStatuses.AT_PICK_UP,
  TripStatuses.PICKED_UP,
  TripStatuses.TO_DROP_OFF,
  TripStatuses.AT_DROP_OFF,
  TripStatuses.COMPLETED
]
export const allowNoShowButtonStatuses = [
  TripStatuses.ACCEPTED,
  TripStatuses.SCHEDULE_ACCEPTED,
  TripStatuses.TO_PICK_UP,
  TripStatuses.AT_PICK_UP
]

export const tripIndicatorReloadStatuses = [
  TripStatuses.ACCEPTED,
  TripStatuses.SCHEDULE_ACCEPTED,
  TripStatuses.SCHEDULED,
  TripStatuses.MANUALLY_COMPLETED,
  ...cancelledTripsStatusesDashboard,
  ...incompleteTripStatusesDashboard,
  ...failedTripStatusesDashboard
]

const getStageByStatusStrategy = [
  {
    stage: TripStages.requesting,
    toFindByStatus: (status: string): boolean => requestingTripStatuses.some(it => it === status)
  },
  {
    stage: TripStages.waitingForPickUp,
    toFindByStatus: (status: string): boolean => waitingForPickupTripStatuses.some(it => it === status)
  },
  {
    stage: TripStages.enRoute,
    toFindByStatus: (status: string): boolean => enRouteTripStatuses.some(it => it === status)
  },
  {
    stage: TripStages.completed,
    toFindByStatus: (status: string): boolean => completedTripStatuses.some(it => it === status)
  }
]

export const getStageByStatus = (status: string): string => {
  const stageStrategyResult = getStageByStatusStrategy.find(it => it.toFindByStatus(status))
  return (stageStrategyResult && stageStrategyResult.stage) || 'UNSUPPORTED'
}



// WEBPACK FOOTER //
// ./src/constants/trip-statuses.ts